export var DEFAULT_HOOKS = ['activate', 'mount', 'update'];
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/vue/esm/constants.js
// module id = 255
// module chunks = 0